import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import BadgedAvatar from "../../../features/base/BadgedAvatar";
import { findRoutineComment } from "../../../redux/routine/routineCommentListSlice";
import { RoutineCommentInfo } from "../../../redux/routine/routineCommentSlice";
import { RoutineItemOptionInfo } from "../../../redux/routine/routineItemOptionSlice";
import { RoutineItemInfo } from "../../../redux/routine/routineItemSlice";
import { RoutineRecordInfo } from "../../../redux/routine/routineRecordSlice";
import { StudentInfo } from "../../../redux/student/studentSlice";
import RoutineCommentCell from "./RoutineCommentCell";
import RoutineItemOptionsCell from "./RoutineItemOptionsCell";
import RoutineItemCell from "./RoutineItemsCell";

interface RoutineTableContainerProps {
    classroomId: string;
    eventDate: string;
    classroomStudents: StudentInfo[];
    routineItems: RoutineItemInfo[];
    routineItemOptions: RoutineItemOptionInfo[];
    routineRecords: RoutineRecordInfo[];
    routineComments: RoutineCommentInfo[];
}

const RoutineTableContainer = ({
    eventDate,
    classroomId,
    classroomStudents,
    routineItems: routineItemsToPresent,
    routineItemOptions,
    routineRecords,
    routineComments
}: RoutineTableContainerProps) => {
    if (!classroomStudents || classroomStudents.length === 0) {
        return (
            <Typography variant="body1" sx={{ m: 2 }}>
                Nenhum aluno presente nesta sala.
            </Typography>
        );
    }
    return (
        <TableContainer sx={{ mt: 2 }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell sx={{ whiteSpace: "nowrap" }}>Itens</TableCell>
                        <TableCell sx={{ width: 1, whiteSpace: "nowrap" }}>Opções</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...(classroomStudents || [])]
                        .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                        .map(student => (
                            <>
                                <TableRow key={student.id}>
                                    <TableCell rowSpan={routineItemsToPresent.length}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <BadgedAvatar
                                                avatar={student.url}
                                                title={student.name}
                                                size="48px"
                                                fontSize="small"
                                            />
                                            <Typography variant="body2" sx={{ width: "150px" }}>
                                                {student.name}
                                            </Typography>
                                        </Stack>
                                    </TableCell>
                                    {routineItemsToPresent[0] &&
                                        routineItemsToPresent[0].id !== "comment" ? (
                                            <>
                                                <TableCell sx={{ py: 3 }}>
                                                    <RoutineItemCell item={routineItemsToPresent[0]} />
                                                </TableCell>
                                                <TableCell sx={{ py: 3 }}>
                                                    <RoutineItemOptionsCell
                                                        classroomId={classroomId}
                                                        studentId={student.id}
                                                        eventDate={eventDate}
                                                        item={routineItemsToPresent[0]}
                                                        routineItemOptions={routineItemOptions}
                                                        routineRecords={routineRecords}
                                                    />
                                                </TableCell>
                                            </>
                                        ) : (
                                            <TableCell sx={{ py: 3 }} colSpan={2}>
                                                <RoutineCommentCell
                                                    schoolId={student.schoolId}
                                                    classroomId={classroomId}
                                                    studentId={student.id}
                                                    eventDate={eventDate}
                                                    item={routineItemsToPresent[0]}
                                                    routineComment={
                                                        findRoutineComment(routineComments, routineItemsToPresent[0].routineId, 
                                                            classroomId, student.id, eventDate)?.comment
                                                    }
                                                />
                                            </TableCell>
                                        )
                                    }
                                </TableRow>
                                {routineItemsToPresent.slice(1).map(item => (
                                    <TableRow key={student.id + "-" + item.id}>
                                        { item.id !== "comment" ? (
                                            <TableCell sx={{ py: 3 }}>
                                                <RoutineItemCell item={item} />
                                            </TableCell>
                                        ) : (
                                            <TableCell sx={{ py: 3 }} colSpan={2}>
                                                <RoutineCommentCell
                                                    schoolId={student.schoolId}
                                                    classroomId={classroomId}
                                                    studentId={student.id || ""}
                                                    eventDate={eventDate}
                                                    item={item}
                                                    routineComment={
                                                        findRoutineComment(routineComments, routineItemsToPresent[0].routineId, 
                                                            classroomId, student.id, eventDate)?.comment
                                                    }
                                                />
                                            </TableCell>
                                        ) }
                                        <TableCell sx={{ py: 3 }}>
                                            { item.id !== "comment" ? (
                                                <RoutineItemOptionsCell
                                                    classroomId={classroomId}
                                                    studentId={student.id || ""}
                                                    eventDate={eventDate}
                                                    item={item}
                                                    routineItemOptions={routineItemOptions}
                                                    routineRecords={routineRecords}
                                                />
                                            ) : (
                                                <></>
                                            ) }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RoutineTableContainer;
